export type BackgroundPattern = {
  key: string
  name: string
  className: string
  description: string
}

export const BACKGROUND_PRESETS: BackgroundPattern[] = [
  {
    key: "none",
    name: "None",
    className: "bg-none",
    description: "Solid color background with no pattern",
  },
  {
    key: "aurora",
    name: "Aurora",
    className: "bg-aurora",
    description: "An aurora inspired wave",
  },
  {
    key: "dream",
    name: "Dream",
    className: "bg-dream",
    description: "Maybe it is a dream?",
  },
  {
    key: "sunset",
    name: "Sunset",
    className: "bg-sunset",
    description: "Purple Sunset",
  },
  {
    key: "diagonal-cross",
    name: "Diagonal Cross",
    className: "bg-diagonal-cross",
    description: "Intersecting diagonal lines forming a subtle cross-hatch pattern",
  },
  {
    key: "dots",
    name: "Dots",
    className: "bg-dots",
    description: "Regular grid of small dots",
  },
  {
    key: "grid",
    name: "Grid",
    className: "bg-grid",
    description: "Simple grid lines forming squares",
  },
  {
    key: "cross",
    name: "Cross",
    className: "bg-cross",
    description: "Simple crosshatch lines",
  },
  {
    key: "pastel-wave",
    name: "Pastel Wave",
    className: "bg-pastel-wave",
    description: "Pastel inspired wave gradient",
  },
  {
    key: "circuit",
    name: "Circuit",
    className: "bg-circuit",
    description: "Simple circuit inspired lines",
  },
  {
    key: "fog",
    name: "Fog",
    className: "bg-fog",
    description: "Moonlight inspired fog",
  },
  {
    key: "diagonal-lines",
    name: "Diagonal Lines",
    className: "bg-diagonal-lines",
    description: "Parallel diagonal lines at 45 degrees",
  },
  {
    key: "zigzag",
    name: "Zigzag",
    className: "bg-zigzag",
    description: "Chevron zigzag pattern",
  },
  {
    key: "checkerboard",
    name: "Checkerboard",
    className: "bg-checkerboard",
    description: "Classic checkerboard pattern",
  },
  {
    key: "waves",
    name: "Waves",
    className: "bg-waves",
    description: "Gentle wave pattern",
  },
]
